export const environment = {
  production: true,
  baseRef: '/psekasmoi/dashboard/'
};



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/environments/environment.ts